import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { DeleteRodRequestErrorProps } from './types';
import { DeleteRodRequestErrorCode } from '@bechtel/types';

const getErrorMessage = (error: DeleteRodRequestErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case DeleteRodRequestErrorCode.INVALID_ROD_REQUEST_ID:
      return <Trans>Invalid rod request id.</Trans>;
    case DeleteRodRequestErrorCode.ROD_REQUEST_ALREADY_CLOSED:
      return <Trans>Rod request already closed.</Trans>;
    case DeleteRodRequestErrorCode.ROD_REQUEST_ALREADY_DELETED:
      return <Trans>Rod request already deleted.</Trans>;
    case DeleteRodRequestErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    case DeleteRodRequestErrorCode.DELETE_ROD_REQUEST_ERRORED:
      return <Trans>Error in deleting rod request.</Trans>;
    case DeleteRodRequestErrorCode.ALL_ISSUED_CADDIES_NOT_RETURNED:
      return <Trans>All issued caddies not returned.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const DeleteRodRequestError: FC<DeleteRodRequestErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Delete Rod Request Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
